import React, { useContext } from 'react'
import { Button, NotificationManagerContext, Spacer, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useOrganizationWithOptions, useRemovePage,
   useUpdateOrganization } from 'src/graphql/hooks'

const CustomAppDeleteConfirm = ({
   onCancelButtonClick,
   onDelete,
   pageId,
   pageTitle
}) => {
   const { showNotification } = useContext(NotificationManagerContext)
   const { removePage, mutating } = useRemovePage()
   const { organization } = useOrganizationWithOptions({
      withGlobalNavLinksTargetMetadata: true
   })

   const { updateOrganization } = useUpdateOrganization({
      variables: {
         withGlobalNavLinksTargetMetadata: true
      }
   })

   const pageGlobalNavLink = organization.globalNavLinks.find(l => l.page?.id === pageId)

   const handleDeleteCustomApp = async () => {
      try {
         // TODO: For now, while pages are pretending to be custom apps,
         // We manually sync updates to globalNavLinks
         // PR #692
         // First, remove globalNavLink, as we want to remove that before removing its
         // corresponding page
         await updateOrganization({
            globalNavLinks: [{
               operation: 'remove',
               remove: pageGlobalNavLink.id
            }]
         })

         // Then remove page
         await removePage({ id: pageId })

         if (onDelete) {
            onDelete()
         }
      } catch (err) {
         showNotification({
            message: err.message,
            title: 'Error!',
            type: 'error'
         })
      }
   }

   return (
      <View>
         <View
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            padding="15px"
            borderBottom="1px solid #eee">
            <Text size="2" weight="medium">
               Confirm Deletion
            </Text>
         </View>
         <View padding="15px" textAlign="center">
            <View>
               <Text size="1.5" color="#444">
                  Are you sure you want to delete&nbsp;
                  <b>{pageTitle}</b>
                  ? This action cannot be undone.
               </Text>
               <Spacer size="2" />
            </View>
            <Spacer size="3" />
            <View display="flex" justifyContent="space-between">
               <Button
                  onClick={onCancelButtonClick}
                  width="48%"
                  name="Cancel"
                  color="#fff"
                  size="md"
                  textColor="#666"
                  textSize="0.9"
               />
               <Button
                  onClick={handleDeleteCustomApp}
                  width="50%"
                  type="submit"
                  name="Delete"
                  color="#ee5248"
                  size="md"
                  textColor="#fff"
                  textSize="0.9"
                  mode={mutating ? 'loading' : 'normal'}
               />
            </View>
         </View>
      </View>
   )
}

CustomAppDeleteConfirm.propTypes = {
   onCancelButtonClick: PropTypes.func.isRequired,
   onDelete: PropTypes.func.isRequired,
   pageId: PropTypes.string.isRequired,
   pageTitle: PropTypes.string.isRequired
}

export default CustomAppDeleteConfirm
